import { render, staticRenderFns } from "./DuelsGameRoller.vue?vue&type=template&id=367b0ffa&scoped=true"
import script from "./DuelsGameRoller.vue?vue&type=script&lang=js"
export * from "./DuelsGameRoller.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameRoller.vue?vue&type=style&index=0&id=367b0ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b0ffa",
  null
  
)

export default component.exports